(function () {

    angular
        .module('ngmvac')
        .directive('custPopo', custPopover);

    function custPopover($compile) {
        return {     
        restrict: 'A',        
        template: '<span class="label-promocion"><i class="fa fa-gift gift-orange" aria-hidden="true"></i> Promociones</span>',
        link: function (scope, element, attrs) {
            
            var rooms = JSON.parse(attrs.custPopo);
            
            var arr = [];
            angular.forEach(rooms, function(room){
                if(angular.isDefined(room.promotions)){
                   angular.forEach(room.promotions, function(promotion){
                        arr.push(promotion);
                   });
                }
            });
            // console.log(arr,'name');
            scope.ofertas = arr;
            
            var temp = '<ul class="esp"><li class="label-promociontext spa" ng-repeat="item in ofertas"><i class="fa fa-check" aria-hidden="true"></i> {{item.name}}</li></ul>';
            var contents = $compile(temp)(scope);
            $(element).popover({
                trigger: 'hover',
                html: true,
                content:  contents,
                placement: attrs.popoverPlacement
                
            });
        }
    };
    } 
})();